import { createRoot } from "react-dom/client";
import "./styles.css";
import { App } from "./app";

const root = document.getElementById("root");
if (!root) throw new Error("Missing application root");
createRoot(root).render(<App />);
